import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsEmailRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsEmailRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { HelpCenterSettingsEmailAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-email/src/HelpCenterSettingsEmailAppEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { HelpCenterSettingsEmail, LazyHelpCenterSettingsEmail } from './ui/email/index.tsx';

const HelpCenterSettingsEmailEntryPoint: ReturnType<typeof createPageEntryPoint> =
	createPageEntryPoint({
		main,
	});

export const helpCenterSettingsEmailRouteEntry: Route = createEntry(
	helpCenterSettingsEmailRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.email',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: HelpCenterSettingsEmail,
		entryPoint() {
			return fg('csm_ai_channel_aware_prompt_instructions')
				? HelpCenterSettingsEmailEntryPoint
				: undefined;
		},
		forPaint: [LazyAtlassianNavigation, LazyHelpCenterSettingsEmail],
		resources: [...getServiceDeskSettingsResources(), customerExperiencesNavigationResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
